import React from "react";
import { FiCheck } from "react-icons/fi";

const CheckIcon = FiCheck;

const SavedView = ({ t, onBackToProfile }) => (
  <div className="pp-family-view mx-auto grid min-h-[62vh] w-full max-w-[33rem] content-center gap-6 pb-2 text-center">
    <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-emerald-500/80 text-white shadow-[0_1rem_2rem_rgba(5,150,105,0.22)]">
      <CheckIcon className="h-12 w-12" />
    </div>
    <div>
      <h2 className="m-0 text-[1.35rem] font-black text-slate-950 dark:text-slate-50">
        {t("common.saved", { defaultValue: "Saved!" })}
      </h2>
      <p className="mx-auto mt-2 max-w-[17rem] text-[0.92rem] font-semibold leading-relaxed text-slate-600 dark:text-slate-300">
        {t("parentPortal.children.save_success", {
          defaultValue: "The changes have been saved successfully.",
        })}
      </p>
    </div>
    <button
      type="button"
      onClick={onBackToProfile}
      className="mx-auto inline-flex min-h-12 w-full max-w-[18rem] items-center justify-center rounded-xl bg-emerald-600 px-4 text-[0.9rem] font-black text-white"
    >
      {t("parentPortal.children.back_to_profile", { defaultValue: "Back to profile" })}
    </button>
  </div>
);

export default SavedView;
